import { ButtonBadge, ButtonWrapper } from './Button.styles'

interface ButtonProps {
  children: React.ReactNode
  block?: boolean
  variant?: 'primary' | 'secondary' | 'red' | 'link' | 'light'
  onClick?: () => void
  badge?: number
  size?: 'sm' | 'lg'
  disabled?: boolean
}

const Button = ({ children, block, variant = 'primary', onClick, badge, size, disabled }: ButtonProps) => {
  return (
    <ButtonWrapper block={block} variant={variant} size={size} onClick={onClick} disabled={disabled}>
      {children}
      {badge && <ButtonBadge>{badge}</ButtonBadge>}
    </ButtonWrapper>
  )
}

export default Button
